module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_resort-b68cae22fd277f98e51ad9eefe4e02a4.webp";